import { Card } from "@/components/ui/card";

// Phase 06: aggregation endpoints land alongside subscription metering. Until
// then the dashboard renders an empty-state card so the layout is preserved
// and the route exercises every other panel.
export default function UsageMetrics() {
  return (
    <Card className="p-4">
      <h2 className="text-lg font-semibold mb-2">My Usage Statistics</h2>
      <p className="text-sm text-muted-foreground">
        Per-user encode/decode aggregates land with the subscription metering
        work in Phase 06.
      </p>
    </Card>
  );
}
